import dayjs from 'dayjs';

export default {
  setAdminReviewList(state, list) {
    state.adminReviewList = [...state.adminReviewList, ...list];
  },

  initList(state) {
    state.pageInfo = {};
    state.page = 1;
    state.totalPage = 2;
    state.adminReviewList = [];
  },

  setPage(state, page = 1) {
    state.page = page;
  },

  setDetail(state, detail) {
    state.adminReviewInfo = detail;
  },

  setTotalPage(state, totalPage = 2) {
    state.totalPage = totalPage;
  },

  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  },

  setReviewRepl(state, reviewRepl) {
    const findIndex = state.adminReviewList.findIndex(
      (item) => Number(item.reviewNo) === Number(reviewRepl.reviewNo)
    );
    if (findIndex !== -1) {
      state.adminReviewList[findIndex].repl.content = reviewRepl.content;
      state.adminReviewList[findIndex].repl.regDate =
        dayjs().format('YYYY-MM-DD');
    }
  }
};
